import script from "./SuperadminDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperadminDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./SuperadminDashboardView.vue?vue&type=style&index=0&id=248f7456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-248f7456"]])

export default __exports__